/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import { SurveyActionData } from '../../model/surveyData';
import { ScopeQuestionGroupOptionalValue } from '../../types/survey';
import { getIconByStatus } from '../../utils/universalTrackerValue';

export const extractUtrIds = (survey: SurveyActionData, utrvIds: string[]) => {
  if (!Array.isArray(utrvIds)) {
    return [];
  }

  const utrSet = new Set<string>();
  utrvIds.forEach(id => {
    const utrv = survey.fragmentUniversalTrackerValues.find(({ _id }) => _id === id);
    if (utrv) {
      utrSet.add(utrv.universalTrackerId)
    }
  });

  return Array.from(utrSet);
};

const awardClass = 'fa fa-award';


export interface IdsContainer {
  utrIds: string[]
}

interface Items extends IdsContainer {
  value: string;
  label: string;
  title: string;
  checked: boolean;
  className: string;
  actions?: { className: string }[] | undefined;
}

interface Group extends IdsContainer {
  value: string;
  label: string;
  title: string;
  children: Items[];
  checked?: boolean
}


export interface AssuranceQuestion {
  label: string;
  title: string;
  utrIds: string[];
  checked: false | boolean;
  children: Group[] | Items[];
  disabled: false | boolean;
}

export const convertQuestionGroupToTree = (questionGroups: ScopeQuestionGroupOptionalValue[], utrIds: string[]) => {

  return questionGroups.map(({ list, groupName }) => {

    const children: Items[] = [];
    let subGroup: Group[] = [];

    list.forEach(({ universalTracker: utr, utrv }) => {
      const title = `${utr.getShortPrefix(utr.getType())} ${utr.getName(utr.getType())}`;
      const status = utrv ? utrv?.status : '';
      const items: Items = {
        value: utr.getId(),
        label: title,
        title: title,
        utrIds: [utr.getId()],
        checked: utrIds.includes(utr.getId()),
        className: 'wwg-award',
        actions: [{ className: `fa ${getIconByStatus(status)} question-status` }, { className: awardClass }],
      };

      children.push(items);
    });

    const idContainer: IdsContainer[] = subGroup.length ? subGroup : children;
    const allIds: string[] = idContainer.reduce((a, c) => {
      a.push(...c.utrIds);
      return a;
    }, [] as string[]);

    return {
      label: groupName,
      title: groupName,
      utrIds: allIds,
      checked: allIds.length > 0 && allIds.every((id) => utrIds.includes(id)),
      children: subGroup.length > 0 ? subGroup : children,
      disabled: subGroup.length === 0 && children.length === 0,
    } as AssuranceQuestion
  });
};


export const extractUtrvIds = (survey: SurveyActionData, nodes: IdsContainer[]) => {

  const utrIds: string[] = [];
  nodes.forEach(n => utrIds.push(...n.utrIds));

  const utrvIds = [];
  for (const v of survey.fragmentUniversalTrackerValues) {
    if (utrIds.includes(v.universalTrackerId)) {
      utrvIds.push(v._id);
    }
  }

  return utrvIds;
};
